<script setup lang="ts">
import VersionChecker from "@/components/shared/VersionChecker.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

const { t } = useI18n();
const route = useRoute();

const isLoginRoute = computed(
  () =>
    route.path === "/auth/login" ||
    route.path.startsWith("/sso/") ||
    route.path.startsWith("/auth/sso/")
);
</script>

<template>
  <v-layout>
    <v-main
      class="tw:flex tw:flex-col tw:items-center tw:justify-center tw:h-dvh tw:bg-[#0E2B3A] tw:md:bg-background"
    >
      <VersionChecker no-offset />
      <div
        class="tw:w-full tw:flex-1 tw:min-h-0 tw:flex tw:items-center tw:justify-center tw:relative"
      >
        <v-card
          class="tw:w-[25rem] tw:max-w-full tw:mx-2! tw:md:w-[70%] tw:md:h-[70%] tw:order-1 tw:md:order-0 tw:z-layer-1! tw:flex tw:flex-col tw:overflow-hidden login-card"
          elevation="8"
          variant="elevated"
          rounded="xl"
        >
          <div class="tw:flex tw:lg:hidden tw:justify-start tw:shrink-0 tw:pt-6 tw:px-6">
            <v-img
              src="/logo_color.svg"
              alt="Logo"
              class="tw:h-6 tw:md:h-8 tw:w-auto tw:max-w-full"
            />
          </div>
          <v-container
            class="tw:h-full tw:relative tw:flex-1 tw:min-h-0 tw:overflow-auto tw:p-6! tw:pt-0! tw:lg:pt-6!"
          >
            <router-view />
          </v-container>
        </v-card>
        <div
          class="tw:absolute tw:top-0 tw:left-0 tw:h-full tw:w-full tw:lg:w-[45%] tw:bg-[#0E2B3A] tw:flex tw:justify-end tw:items-center tw:lg:!z-1"
        >
          <v-img
            src="/images/auth-bg.jpg"
            alt="Background Image"
            class="tw:absolute! tw:top-0 tw:left-0 tw:w-full tw:h-full tw:opacity-15 tw:lg:opacity-3 tw:object-cover"
            cover
          />
          <div
            class="tw:hidden tw:lg:flex tw:items-center tw:w-[66.6%] tw:h-[70%] tw:bg-[#0E2B3A] tw:rounded-l-3xl tw:overflow-hidden tw:relative"
          >
            <v-img
              src="/images/auth-bg.jpg"
              alt="Background Image"
              class="tw:absolute! tw:top-0 tw:left-0 tw:w-full tw:h-full tw:opacity-10 tw:object-cover"
              cover
            />
            <div class="tw:grow tw:text-center tw:relative">
              <div class="tw:inline-block tw:text-left tw:max-w-9/10 tw:mx-auto">
                <v-img
                  src="/logo.svg"
                  alt="Logo"
                  class="tw:w-50 tw:max-w-full"
                />
              </div>
            </div>
            <div class="tw:basis-0">
              <v-btn
                to="/auth/login"
                :class="[
                  'tw:w-full tw:rounded-r-none!',
                  {
                    'tw:opacity-100!': isLoginRoute,
                  },
                ]"
                size="x-large"
                height="60px"
                rounded="lg"
                variant="flat"
                :color="isLoginRoute ? 'white' : 'transparent'"
              >
                <span
                  :class="{
                    'tw:text-secondary': isLoginRoute,
                    'tw:text-white': !isLoginRoute,
                  }"
                >
                  {{ t("models.auth.actions.logIn") }}
                </span>
              </v-btn>
              <v-btn
                href="https://www.cotreatme.com/"
                target="_blank"
                rel="noopener noreferrer"
                class="tw:w-full tw:rounded-r-none!"
                size="x-large"
                height="60px"
                rounded="lg"
                color="transparent"
                variant="flat"
              >
                <span class="tw:text-white">
                  {{ t("models.auth.connect.about") }}
                </span>
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </v-main>
  </v-layout>
</template>

<style scoped lang="scss">
@layer vuetify-overrides {
  .login-card {
    box-shadow:
      0 1px 2px rgba(14, 43, 58, 0.04),
      0 8px 24px -6px rgba(14, 43, 58, 0.08),
      0 32px 64px -16px rgba(14, 43, 58, 0.14) !important;
  }
}

.v-btn--active {
  :deep(.v-btn__overlay) {
    --v-theme-overlay-multiplier: 0 !important;
  }
}
</style>
